import { PartyPopper, Briefcase, Coffee, Users, Music, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const SERVICES = [
  { icon: PartyPopper, title: "Private Celebrations", type: "Private Celebration", text: "Birthdays, anniversaries, family gatherings and private parties — music your guests will hum all the way home." },
  { icon: Briefcase, title: "Corporate Events", type: "Corporate Event", text: "Musical entertainment for corporate gatherings, celebrations and employee events, delivered with polish." },
  { icon: Coffee, title: "Restaurants & Cafés", type: "Restaurant / Café", text: "Live karaoke-based entertainment for venues looking to create a memorable, linger-longer atmosphere." },
  { icon: Users, title: "Society & RWA Events", type: "Society / RWA Event", text: "Community gatherings, celebrations and cultural evenings that bring every generation together." },
  { icon: Music, title: "Concerts", type: "Concert", text: "Larger-scale musical evenings featuring multiple performers, with expanded production coordinated to scale." },
];

export default function Services({ onEnquire }) {
  return (
    <section id="services" className="py-20 lg:py-28" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          eyebrow="What We Do"
          title="Music for Every Occasion"
          sub="Karaoke-based live singing, tailored to your event. Live band accompaniment can be arranged at an additional cost."
        />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={0.06 * i} className={i === 4 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <div className="tk-card group flex h-full flex-col p-7 transition-all duration-300 hover:-translate-y-1 hover:border-gold/40" data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 text-gold transition-colors group-hover:bg-gold group-hover:text-navy-950">
                  <s.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-serif text-xl font-semibold text-ivory">{s.title}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-400">{s.text}</p>
                <button
                  onClick={() => onEnquire(s.type)}
                  data-testid={`service-enquire-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-gold transition-colors hover:text-gold-light"
                >
                  Enquire About This Event <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </button>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <div className="flex h-full flex-col justify-center rounded-2xl border border-burgundy/50 bg-gradient-to-br from-burgundy/40 to-navy-850 p-7" data-testid="services-pricing-note">
              <p className="font-serif text-xl font-semibold text-ivory">Every event is different.</p>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-300">
                Pricing depends on performers, duration, event size, location and sound. Contact us
                for a customized quotation — no fixed packages, no hidden surprises.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
